import React, { useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../ducks/hooks';
import { Menu, Layout, SiderProps } from 'antd';
import type { GetProp, MenuProps } from 'antd';
import { Link, useLocation } from 'react-router';
import { MenuEntry, selectIsUserLoaded, selectLayoutState, selectMenuData, selectUserGroups, setLayoutState, setMenuData } from '../../../../ducks/app';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { default as stdMenuData } from './menuData/menuData';
import { default as assessorMenuData } from './menuData/assessorMenuData';
import { default as ccMenuData } from './menuData/ccMenuData';
import { default as solicitorMenuData } from './menuData/solicitorMenuData';
import { default as caMenuData } from './menuData/caMenuData';
import { default as ccommissionerMenuData } from './menuData/ccommMenuData';
import { UserRoles } from '../../../../commontypes/types';
import './style.scss'
import { getDefaultPath } from "../../../../routes/routes";

const { Sider } = Layout

interface MenuLeftProps {
  isMobile: boolean;
}

type MenuItem = GetProp<MenuProps, 'items'>[number];


const MenuLeft: React.FC<MenuLeftProps> = ({ isMobile }) => {
  const pathname = useLocation().pathname;
  const settingsOpened = useAppSelector(state => state.app.layoutState.settingsOpened);
  const layoutState = useAppSelector(selectLayoutState);
  const userGroups = useAppSelector(selectUserGroups);
  const isUserLoaded = useAppSelector(selectIsUserLoaded)
  const [selectedKeys, setSelectedKeys] = useState('');
  const [openKeys, setOpenKeys] = useState(['']);
  const [appealDetail, setAppealDetail] = useState(false);
  const dispatch = useAppDispatch();

  const getLeftMenuIcon = (name: string) => name ? (<span className={`icmn icmn-${name} menuLeft__icon`}></span>) : '';

  const setMenuDataForUser = ( ) => {
    let allMenuData = stdMenuData;
    if (userGroups.includes(UserRoles.COUNTY_ADMIN)) {
      allMenuData = caMenuData;
    }
    if (userGroups.includes(UserRoles.COUNTY_CLERK)) {
      allMenuData = ccMenuData;
    }
    if (userGroups.includes(UserRoles.ASSESSOR)) {
      allMenuData = assessorMenuData;
    }
    if (userGroups.includes(UserRoles.SOLICITOR)) {
      allMenuData = solicitorMenuData;
    }
    if (userGroups.includes(UserRoles.COUNTY_COMMISSIONER)) {
      allMenuData = ccommissionerMenuData;
    }
    dispatch(setMenuData(allMenuData));
  };


  useEffect(() => {
    if (isUserLoaded) {
      setMenuDataForUser();
    }
  }, [isUserLoaded]);

  const menuData = useAppSelector(selectMenuData);
  const menuItems: MenuItem[] = useMemo(() => {
    const instructionsMenu: MenuItem = {
      key: 'help',
      icon: getLeftMenuIcon('info'),
      label: (<React.Fragment>
        <a href="https://brttechnologies.com/appeal%20support" target="_blank" rel="noopener noreferrer">Appeal Instructions</a>
      </React.Fragment>)
    };
    const menuItemsWithoutInstructions = generateMenuItems(menuData);
    return [...menuItemsWithoutInstructions, instructionsMenu];
  }
, [menuData]);

  useEffect(() => {
    if (menuData) {
      getActiveMenuItem(menuItems);
    }
  }, [menuItems, pathname])

  const handleClick: MenuProps['onClick'] = e => {
    if (isMobile) {
      // collapse menu on isMobile state
      dispatch(setLayoutState({ menuMobileOpened: false }));
    };
    if (e.key === 'settings') {
      // prevent click and toggle settings block on theme settings link
      dispatch(setLayoutState({ settingsOpened: !settingsOpened }))
      return;
    };
    // set current selected keys
    setSelectedKeys(e.key);
  }

  const onOpenChange: MenuProps['onOpenChange'] = openKeys => {
    setOpenKeys(openKeys);
  }

  function getPath(menuItems: MenuItem[], id: string, parents: MenuItem[] = []): MenuItem[] {
    const key = id.substring(1);
    let items = menuItems.reduce(
      (pathItems: MenuItem[], item: MenuItem) => {
        if (pathItems.length) {
          return pathItems;
        } else if (item && "children" in item && item.children) {
          let nested = getPath(item.children, id, [item, ...parents])
          return nested.length ? nested : pathItems;
    } else if (item && item.key === key) {
          return [item, ...parents]
            }
        return pathItems;
      },
      [] as MenuItem[],
    );
    //return items.length > 0 ? items : false
    return items;
  }

  const getActiveMenuItem = (items:MenuItem[]) => {
    //let [activeMenuItem, ...path] = getPath(items, !selectedKeys ? pathname : selectedKeys);
    let [activeMenuItem, ...path] = getPath(items, pathname === "/" ? getDefaultPath() : pathname);
    const key = (activeMenuItem?.key || '').toString();
    setSelectedKeys(key);
    setOpenKeys(activeMenuItem ? path.map(entry => (entry?.key || '').toString()) : []);
  }

  function generateMenuItems(items: MenuEntry[]): MenuItem[] {
    return items.map(menuItem => {
      if ("children" in menuItem && menuItem.children) {
        return {
          key: menuItem.key,
          label: menuItem.title,
          icon: getLeftMenuIcon(menuItem.icon || ''),
          children: generateMenuItems(menuItem.children)
        }
      }
      return generateMenuItem(menuItem);
    })
  }

  function generateMenuItem(entry: MenuEntry): MenuItem{
    const { key, title } = entry;
    return "url" in entry ? {
        key,
        
        disabled: !!entry.disabled,
        icon: getLeftMenuIcon(entry.icon || ''),
        label: (
          <Link
            to={entry.url}
            onClick={
              undefined
            }
          >
            <span className="menuLeft__item-title">{title}</span>
          </Link>
        )
      }
        : { key, disabled: !!entry.disabled, icon: getLeftMenuIcon(entry.icon || ''), title };
  }

  useEffect(() => {
    let appealDetail = pathname.includes("/appeal/");
    if (appealDetail) {
      setAppealDetail(true);
    }
    getActiveMenuItem(menuData)
  }, []);

  const paramsMobile: SiderProps = {
    width: 256,
    collapsible: false,
    collapsed: false,
    breakpoint: 'sm'
  };
  const paramsDesktop: SiderProps = {
    width: appealDetail ? 0 : 256,
    // collapsible: true,
    // collapsed: collapsed,
    // onCollapse: this.onCollapse,
    breakpoint: 'lg',
  };
  const params = isMobile ? paramsMobile : paramsDesktop;

  if (appealDetail) {
    return (<div></div>);
  }

  return (
    <Sider {...params} className="menuLeft">
      <div className="menuLeft__logo">
        {params.collapsed ? (
          <div className="menuLeft__logoContainer menuLeft__logoContainer--collapsed">
            <img src="resources/images/brt/njappeal157x.png" alt="" />
          </div>
        ) : (
          <div className="menuLeft__logoContainer">
            <img
              src="resources/images/brt/mynjbackdrop3.jpg"
              height="200"
              width="230"
              alt=""
            />
          </div>
        )}
      </div>
      <Scrollbars
        autoHide
        style={{ height: isMobile ? 'calc(100vh - 64px)' : 'calc(100vh - 112px)' }}
      >
        <Menu
          theme={layoutState.themeLight ? 'light' : 'dark'}
          onClick={handleClick}
          selectedKeys={[selectedKeys]}
          openKeys={openKeys}
          onOpenChange={onOpenChange}
          mode="inline"
          className="menuLeft__navigation"
          items={menuItems}
        />
      </Scrollbars>
    </Sider>
  );
}

export default MenuLeft;
